<table mat-table [dataSource]="dataSource" style="width: 100%" matSort [trackBy]="trackByFn">

  <ng-container matColumnDef="bmNr">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> BM Nummer</th>
    <td mat-cell *matCellDef="let element"> {{ element.NAME }}</td>
  </ng-container>

  <ng-container matColumnDef="category">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Kategorie</th>
    <td mat-cell *matCellDef="let element"> {{ element.PARENT_MODULE }}</td>
  </ng-container>

  <ng-container matColumnDef="project">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Projekt</th>
    <td mat-cell *matCellDef="let element"> {{ element.PROJECT }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Änderungsstatus</th>
    <td mat-cell *matCellDef="let element"> {{ element.CHANGE_STATUS }}</td>
  </ng-container>

  <ng-container matColumnDef="constStatus">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Konstruktionsstatus</th>
    <td mat-cell *matCellDef="let element"> {{ element.CONSTSTATUS }}</td>
  </ng-container>

  <ng-container matColumnDef="specStatus">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Spezifikationsstatus</th>
    <td mat-cell *matCellDef="let element"> {{ element.STATUSSPEC }}</td>
  </ng-container>

  <ng-container matColumnDef="ai">
    <th mat-header-cell mat-sort-header *matHeaderCellDef> Aktueller Index</th>
    <td mat-cell *matCellDef="let element"> {{ element.INDEX_ZI }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Aktionen</th>
    <td mat-cell *matCellDef="let element">
      <button mat-icon-button color="primary" routerLink="/pm-constructions/{{element.OBJECT_ID}}">
        <mat-icon>info</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
